import $ from 'jquery';

const topSellingPlanObj = {
    variables:{
      topSellingPlanCard : $('.top-selling-plans__plan--outer'),
      topSellingPlanTitle : $('.top-selling-plans__plan__title'),
      topSellingSubHeading : $('.top-selling-plans__plan--sub-heading'),
      url: window.location.href,

    },
    methods:{
        cardsHover:function(){
           const {topSellingPlanCard,topSellingSubHeading,topSellingPlanTitle} = topSellingPlanObj.variables;

           topSellingPlanCard.on('mouseover',function(){
            $(this).find(topSellingSubHeading).show();
            $(this).find(topSellingPlanTitle).css('margin-bottom','0');
           });

           topSellingPlanCard.on('mouseleave',function(){
            $(this).find(topSellingSubHeading).hide();
            $(this).find(topSellingPlanTitle).css('margin-bottom','41px');
           });
        },
        productCardClickHandler : function () {
               $(".top-selling-plans__plan").on('click', function(e){
                      const cardTitle = e.currentTarget.getElementsByClassName("top-selling-plans__plan__title")[0].innerText;
                      const title = $(this).closest('.top-selling-plans').find('.heading-2').text();
                      const productCategory = $(this).find(".top-selling-plans__plan__title").data('productcategory');
                      const obj = topSellingPlanObj.methods.dataLayerObj(cardTitle, title, e, productCategory);
                      createDataLayer("productCardClick", obj);
                      });
                    },
        addEqaualHeight: function(){
          let maxHeight = 0;
          if ($(window).width() > 992) {
            $(".top-selling-plans__plan--outer").each(function () {
              let height = $(this).outerHeight();
              if (height > maxHeight) {
                maxHeight = height;
              }
            });
          }
          $(".top-selling-plans__plan--outer").css("min-height", maxHeight);
        },
        dataLayerObj: function (e,el, ele, productCategory) {
          const obj = {
              'articleName' : "",
              'blogCategory' : "",
              'blogPageCategory' : "",
              'buttonText' : e ? e.replace(/\n/g, '').trim() : "",
              'pageSection' : el ? el.replace(/\n/g, '').trim() : "",
              'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? topSellingPlanObj.variables.url.includes("blog") ? "Blogs" : topSellingPlanObj.variables.url.substring(topSellingPlanObj.variables.url.indexOf(".com/"), topSellingPlanObj.variables.url.lastIndexOf('/')  === ".com") && !topSellingPlanObj.variables.url.substring(topSellingPlanObj.variables.url.indexOf(".com/"), topSellingPlanObj.variables.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
              'planOption' : "",
              'productCategory' : productCategory ?? "",
              'productName' : ele.currentTarget.getElementsByClassName("top-selling-plans__plan--sub-heading")[0].innerText.replace(/\n/g, '').trim(),
              'question' : "",
              'searchTerm' : "",
              'videoTitle' : "",
              'bannerName' : "",
              'bannerType' : ""
          };
          return obj;
      },
        init:function(){
          this.cardsHover();
        }
    }
};
$(document).ready(function () {
 topSellingPlanObj.methods.productCardClickHandler();
 topSellingPlanObj.methods.addEqaualHeight();
 });

$(() => {
    if ($(".top-selling-plans").length > 0) {
        topSellingPlanObj.methods.init();
    }
  });
